export default {
  app: {
    featured: '特集',
    random: 'ランダム',
    explore: '探索',
    keywords: 'キーワード',
    search: '検索',
  },
  explore: {
    filters: 'フィルター',
    resetFilters: '条件をクリア',
    addKeyword: 'キーワードを追加',
  },
  recipe: {
    contributedBy: '提供',
    ingredients: '材料',
    directions: '手順',
    fullRecipe: '完全なレシピを見る',
    similarDrinks: '似ているドリンク',
  },
  featuredRecipes: {
    loadMore: 'もっと見る',
  },
  recipeFind: {
    filterBy: '検索条件',
    name: '名前',
    ingredients: '材料',
    keywords: 'キーワード',
    searchForIngredients: 'スペースで区切ることで複数の材料で検索できます',
    searchForKeywords: 'スペースで区切ることで複数のキーワードで検索できます',
  },
  recipeList: {
    viewRecipe: 'レシピを見る',
  },
  recipeToolbar: {
    print: '印刷',
    share: '共有',
    shareOnFacebook: 'Facebook',
    shareOnTwitter: 'Twitter',
    copyURL: 'URLをコピー',
    hideImage: '画像を非表示',
  },
  favorites: {
    removeAllFavorites: 'お気に入りをすべて削除する',
    noFavoriteDrinks: 'お気に入りのドリンクがありません',
    removeFavoritesPrompt: 'お気に入りをすべて削除してもよろしいですか？',
    delete: '削除',
    cancel: 'キャンセル',
  },
  keywordList: {
    enterYourKeyword: 'キーワードを入力してください',
  },
  search: {
    findYourDrink: 'あなたのドリンクを見つけよう',
  },
  pageNotFound: {
    pageNotFound: 'お探しのページは見つかりませんでした。',
    backToHome: 'ホームに戻る',
  },
};
